import { Routes } from '@angular/router';

// components
import { NotificationViewComponent } from './components/notification-view/notification-view.component';

export const NOTIFICATION_ROUTES: Routes = [
  {
    path: '',
    component: NotificationViewComponent
  },
];
